<template>
  <section class="news-wrapper" v-show="isMobile" @click="newsPostHandle">
    <div class="news-toggle_bar">
      <span style="padding-left: 20px;color: #275edb;">{{
        newsToggleTip
      }}</span>
      <span
        style="padding-right: 24px;color: rgb(128, 128, 128);font-size: 12px;"
        >{{ moreIcon }}</span
      >
    </div>
    <ul class="news-content-wrapper" v-show="isShowed">
      <li
        class="news-post"
        v-for="(postItem, postIdx) of postList"
        :key="postIdx"
        @click="routeTo(postItem.roteName)"
      >
        <span class="news-post-date">{{ postItem.date }}</span>
        <span class="news-post-title">{{ postItem.title }}</span>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "NewsBar",
  data() {
    return {
      isMobile: false,
      isShowed: false,
      moreIcon: "▼",
      newsToggleTip: "Show more News",
      postList: [
        {
          roteName: "May202111",
          date: "May 11",
          title: "Celebrate EID with ToTok!"
        },
        {
          roteName: "one-year",
          date: "August 4",
          title: "Celebrate ToTok’s One Year Anniversary with Us"
        },
        {
          roteName: "Jun202015",
          date: "Jun 15",
          title: "Introducing New Features on ToTok"
        },
        {
          roteName: "EidiyaToTok",
          date: "May 21",
          title: "Send your Eidiya through ToTok!"
        },
        {
          roteName: "newsApr202029",
          date: "April 29",
          title: "Celebrate Ramadan and stay connected with ToTok"
        },
        {
          roteName: "newsMar202023",
          date: "Mar 23",
          title: "PayBy is now live on ToTok in the UAE"
        },
        {
          date: "Mar 11",
          roteName: "newsMar202011",
          title:
            "ToTok Media Statement: A Call for Cooperation with Apple and Google"
        },
        {
          date: "Mar 05",
          roteName: "newsMar202005",
          title: "“Coronavirus Live Updates” is now available on ToTok"
        },
        {
          date: "Feb 23",
          roteName: "newsFeb20200223",
          title: "Message to our ToTok community"
        },
        {
          date: "Feb 20",
          roteName: "newsFeb202020",
          title: "A note to the ToTok community from our cofounders"
        },
        {
          roteName: "newsJan05",
          date: "Jan 05",
          title: "ToTok is back on Google Play"
        },
        {
          roteName: "newsDec29",
          date: "Dec 29",
          title: "ToTok cofounder’s exclusive interview with Khaleej Times"
        },
        {
          roteName: "newsDec27",
          date: "Dec 27",
          title: "Message to Apple and Google from our cofounder"
        },
        {
          roteName: "newsDec24",
          date: "Dec 24",
          title: "A note from the ToTok cofounders"
        },
        {
          roteName: "newsDec22",
          date: "Dec 23",
          title: "A letter to the ToTok community"
        }
      ]
    };
  },
  methods: {
    newsPostHandle() {
      this.isShowed = !this.isShowed;
      if (this.isShowed) {
        this.newsToggleTip = "Hide recent posts";
        this.moreIcon = "▲";
      } else {
        this.newsToggleTip = "Show more posts";
        this.moreIcon = "▼";
      }
    },
    routeTo(routeName) {
      this.$router.push({
        name: routeName
      });
    }
  },
  mounted() {
    if (document.body.clientWidth <= 700) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
};
</script>
<style scoped lang="stylus">
.news-wrapper{
    width: 100%;
    padding-top: 0px;
    .news-toggle_bar{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 50px;
        background-color: #f8f8f8;
        line-height: 32px;
        font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
        font-size: 17px;
        letter-spacing: 0.5px;

    }
    .news-content-wrapper{
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            padding-left: 15px;
            // border-left: 4px solid #3faee8;
            margin-left:0px;
            background: #f8f8f8;
            .news-post{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                padding-left: 10px;
                border-left: 3px solid #4378f2;
                margin: 12px 0px;
                .news-post-date{
                    font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                    font-size: 12px;
                    color: #808080;
                }
                .news-post-title{
                    font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                    font-size: 16px;
                    color: #262626;
                }
            }
        }
}
.news-toggle_bar--active{

}
</style>
